module.exports = __webpack_public_path__ + "static/img/dingzhi_bg.7af70493.jpg";